import { Link } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

import LinkIcon from '@mui/icons-material/Link';
import { IconButton, Theme, useTheme } from '@mui/material';

const useStyles = makeStyles<{ disabled?: boolean; hasName?: boolean }>()((theme: Theme, { disabled, hasName }) => ({
  root: {
    color: disabled ? 'rgba(255, 255, 255, 0.12)' : theme.palette.primary.light,
    marginBottom: '-6px',
    display: 'inline-flex',
    alignItems: 'center',
    textDecoration: 'none',
    gap: hasName ? '3px' : 0,
    ...(disabled && { pointerEvents: 'none' }),
  },
}));

interface FormLinkButtonProps {
  path: string;
  disabled?: boolean;
  onClick?: () => void;
  name?: string;
  // Icon color; defaults to white
  color?: string;
}

const FormLinkButton = ({ path, disabled, onClick, name, color }: FormLinkButtonProps) => {
  const theme = useTheme();
  const styles = useStyles({ disabled, hasName: !!name });

  return (
    <Link className={styles.classes.root} to={path} target="_blank" onClick={onClick}>
      {name && (
        <span
          style={{
            color: '#4aaac0',
            fontSize: '12px',
            fontFamily: 'Inter'
          }}
        >
          {name}
        </span>
      )}
      <IconButton
        sx={{
          padding: 0,
          color: color || theme.palette.common.white,

          '&.Mui-disabled': {
            color: 'rgba(255, 255, 255, 0.08)',
          },
        }}
        disabled={disabled}
        onClick={onClick}
      >
        <LinkIcon />
      </IconButton>

    </Link>
  );
};

export default FormLinkButton;
